export default __webpack_public_path__ + "static/media/habilitar-permiso-camara-android-5.6fa25199.svg";